import React from "react";
import { Card, CardContent, CardActions, Button, Typography, Container } from '@mui/material';

import thanksImg from '../../../../assets/images/authimgs/checked.svg';

const SignupCompletion = () => {


  return (
    <div className="thanks-section">
      <Container maxWidth="sm" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Card  className="greeting-modal-body">
          <CardContent>
           
            <img src={thanksImg} alt="tick" style={{maxWidth:"100px", height:"100px" , objectFit:"contain"}}/>
            <Typography variant="h4" gutterBottom className="greeting-modal-heading">
              Registration Successful!
            </Typography>
            <Typography variant="subtitle1" gutterBottom className="modal-text-block">
             Thank you for registering with us. Please check your email to set up your password.
            </Typography>
           
          </CardContent>
          <CardActions style={{ justifyContent: 'center' }}>
            {/* <Button
            className="btnMain greetings-btn"
            type="submit"
            variant="contained"
            color="success"
            fullWidth
          >
            OK
          </Button> */}
          </CardActions>
        </Card>
      </Container>
    </div>
  );
};

export default SignupCompletion;